/** Anchor id for the template selection grid on /templates */
export const TEMPLATE_GRID_ID = 'choose-template';

/** Anchor id for the selected template description panel on /templates */
export const TEMPLATE_DETAIL_ID = 'template-detail';

/** Anchor id for the pricing section on /digital-card */
export const PRICING_SECTION_ID = 'pricing';

export const TEMPLATES_PATH = '/templates';

export const DIGITAL_CARD_PATH = '/digital-card';

/** Use for Get Started CTAs so users land at template selection, not a preserved scroll position */
export const TEMPLATES_CHOOSE_URL = `${TEMPLATES_PATH}#${TEMPLATE_GRID_ID}`;

/** Nav/footer link target for the digital-card pricing section */
export const DIGITAL_CARD_PRICING_URL = `${DIGITAL_CARD_PATH}#${PRICING_SECTION_ID}`;

export function scrollToDigitalCardSection(sectionId: string, behavior: ScrollBehavior = 'smooth') {
  document.getElementById(sectionId)?.scrollIntoView({ behavior, block: 'start' });
}
